import { render, staticRenderFns } from "./Portfolio.vue?vue&type=template&id=1c114c07&scoped=true&"
import script from "./Portfolio.vue?vue&type=script&lang=ts&"
export * from "./Portfolio.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c114c07",
  null
  
)

export default component.exports